<template>
  <custom-btn-icon
    @click="onClick"
    :btn-text="paused ? 'Relâcher' : 'Libérer'"
    :loading="loading"
    :disabled="loading"
    color="error"
    :icon="paused ? 'mdi-play' : 'mdi-account-cancel'"
  />
</template>

<script>
import CustomBtnIcon from '@/components/displays/CustomBtnIcon';
import { selfUnassign } from '@/services/api/internal/requestActions/selfAssign.api';
import { mapGetters } from 'vuex';
import { catchCRUDError } from '@/business/apiTreatment/response/errorTreatment';

export default {
  name: 'SelfUnassign',
  components: {
    CustomBtnIcon,
  },
  props: {
    requestId: {
      type: Number,
      required: true,
    },
    groupId: {
      type: String,
      required: false,
    },
    paused: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      active: 'requests/active',
    }),
  },
  data() {
    return {
      clicked: false,
      loading: false,
    };
  },
  methods: {
    selfUnassign,
    onClick() {
      this.clicked = true;
      this.loading = true;
      this.selfUnassign(this.requestId, { group_id: this.groupId })
        .then((response) => {
          if (response.status === 200)
            this.$emit('success', response.data.message);
          this.$store.dispatch('requests/refreshItems');
          this.$store.dispatch('requests/removeCurrent', this.requestId);
          this.$store.dispatch('boilerplate/setModalClosed');
        })
        .catch((err) => {
          this.$store.dispatch(
            'snackbar/setSnackbarOpen',
            catchCRUDError('FREE', err)
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
